// extracted by mini-css-extract-plugin
export default {"outerDiv":"LabelUtil_outerDiv__6iQKX","label":"LabelUtil_label__wlXma"};